import React, { Component } from 'react';

import EmailShareCard from './EmailShareCard';

import {
	Button,
	Card,
	CardHeader,
	CardActions
	// Divider
} from 'material-ui';

import Fade from 'material-ui/transitions/Fade';

export default class ShareSuggestionCard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			oid: this.props.oid,
			jid: this.props.jid,
			uid: this.props.uid,
			sharing: true
		};
	}

	handleClick = () => {
		this.setState({
			sharing: !this.state.sharing
		});
	};

	render() {
		const { oid, jid, uid } = this.state;
		return (
			<Fade key="shareCard" in={true}>
				{this.state.sharing ? (
					<EmailShareCard oid={oid} jid={jid} uid={uid} />
				) : (
					<Card className="card rightCard">
						<CardHeader subheader="Know someone who would be a great fit for this role? Send them an exclusive invite now." />
						<CardActions className="cardActions">
							<Button
								onClick={this.handleClick}
								raised
								color="default"
								aria-label="share"
								className="cardActionsBtn"
							>
								Share
							</Button>
						</CardActions>
					</Card>
				)}
			</Fade>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/ShareSuggestionCard.js